export const MAIN_TITLE = 'Citas HDSA';
export const ENTITY = 'Hospital Departamental San Antonio';
